<template>
  <el-container v-loading="loading">
    <!-- 左侧菜单 -->
    <wanMenu></wanMenu>

    <el-container
      style="
        padding: 0 103px 0 117px;
        box-sizing: border-box;
        background: #f1f5f8;
        height: 100vh;
        overflow: hidden auto;
        display: block;
      "
    >
      <wanHeader></wanHeader>

      <el-main v-if="mainLoad">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import wanHeader from "@/components/wan-header";
import wanMenu from "@/components/wan-menu";
import { mapState } from "vuex";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Layout",

  components: {
    wanHeader,
    wanMenu,
  },

  data() {
    return {
      mainLoad: true,
    };
  },

  watch: {
    $route() {
      this.mainLoad = false;
      this.$nextTick(() => {
        this.mainLoad = true;
      });
    },
  },

  computed: {
    ...mapState(["userInfo", "loading"]),
  },

  mounted() {
    // this.$store.commit("setLoading", true);
    if (!this.userInfo || !Object.keys(this.userInfo).length) {
      // 未登录
      this.$router.replace("/login");
    }
  },
};
</script>

<style scoped lang="less">
.el-header,
.el-main {
  padding: 0;
}

.el-main {
  padding-right: 35px;
  box-sizing: border-box;
  overflow: auto;
}
</style>
